import { render } from "./addBookmark.vue?vue&type=template&id=bfa7cd2a"
import script from "./addBookmark.vue?vue&type=script&lang=js"
export * from "./addBookmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__